module.exports = __webpack_public_path__ + "img/campanaSolidaria-Fondo.01e2efff.jpg";